<!-- 公共弹窗 -->
<template>
  <div class='v-dalog'>
    <van-popup v-model="isShowTips" :close-on-click-overlay="false" @close='handleCloseDalog' @click-overlay="handleclickOverlay" style='border-radius:10px;' >
      <div class="dalog-box">
        <div class="dalog-content">
          <div class="dalog-title">{{dalogTitle}}</div>
          <p :style="{'text-align':isCenter?'center':'','margin-bottom':pTagMarginBottom}">{{dalogContent}}</p>
          <div class='kf' v-if='isShowRelationKf'>电话联系客服：<span @click='callPhone("400-969-7756")'>400-969-7756</span></div>
        </div>
        <div class="line"></div>
        <div class="btn-box df-between" v-if='isShowTwoButton'>
          <div class="btn btn-gray df-center" @click='handleBtnLeft' >{{dalogBtn1}}</div>
          <div class="btn df-center" @click='handleBtnRight' >{{dalogBtn2}}</div>
        </div>
        <div class="btn-box df-between" v-else>
          <div class="btn df-center" @click='handleOk' >{{dalogBtn3}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    props:{
      isShowDalog:{
        type:Boolean,
        default:false
      },
      isShowRelationKf:{// 是否显示联系客服
        type:Boolean,
        default:false
      },
      isShowTwoButton:{// 是否显示双按钮
        type:Boolean,
        default:true
      },
      dalogContent:{// 提示内容
        type:String,
        default:''
      },
      isCenter:{// 是否居中显示
        type:Boolean,
        default:false
      },
      pTagMarginBottom:{// 设置P标签的marginBottom
        type:String,
        default:'0px'
      },
      isColor:{// 文字颜色
        type:String,
        default:''
      },
      dalogTitle:{// 标题title
        type:String,
        default:'温馨提示'
      },
      dalogBtn1:{// 按钮1名称
        type:String,
        default:'取消'
      },
      dalogBtn2:{// 按钮2名称
        type:String,
        default:'确认'
      },
      dalogBtn3:{// 按钮3名称
        type:String,
        default:'知道了'
      },
    },
    data() {
      return {
      }
    },
    created() {},
    computed: {
      isShowTips: {
        get() {
          return this.isShowDalog;
        },
        set(newValue) {
          return newValue;
        },
      },
    },
    methods: {
      callPhone(phone){
        this.utils.handleOnTell(phone)
      },
      handleBtnLeft(){
        this.$emit('handleBtnLeft')
      },
      handleBtnRight(){
        this.$emit('handleBtnRight')
      },
      handleOk(){
        this.$emit('handleOk')
      },
      handleCloseDalog(){
        this.$emit('handleCloseDalog')
      },
      handleclickOverlay () {
        this.$emit('handleclickOverlay')
      },
    },
  }
</script>
<style lang='scss' scoped>
.v-dalog{
  .van-popup{
    width: 80%;
  }
  .dalog-box {
    position: relative;
    background-color: #fff;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    border-radius: 10px;
    overflow: hidden;
    .dalog-content {
      padding: 24px 24px 0px;
      border-bottom: 1px solid #eee;
      .dalog-title {
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        margin-bottom: 10px;
        text-align: center;
      }
      p {
        font-size: 14px;
        color: #666;
      }
      .kf{
        margin-bottom: 20px;
        font-size: 14px;
        text-align: center;
        span{
          color: #26b4ff;
        }
      }
    }
    .btn-box {
      color: #26b4ff;
      .btn {
        flex: 1;
        padding: 12px 0px;
      }
      .btn-gray {
        color: #323233;
        border-right: 1px solid #eee;
      }
    }
  }
}
</style>